<template>
    <div class="hours-section">
        <div class="hours-section__container">
            <p class="mt-5 mb-3">{{ $t("wizard.meal") }}</p>
            <div class="midday">
                <div
                    v-ripple
                    v-for="hour in hours.midday"
                    :key="hour"
                    class="hour"
                    :class="{
                        selected: isHourSelected(hour),
                        disabled:
                            !checkIfShiftAvaliable('midday') ||
                            !hourIsAvailable(hour, 'midday')
                    }"
                    @click="setHour({ hour: hour, shift: 'midday' })"
                >
                    <span class="">{{ hour }}</span>
                </div>
            </div>
            <p class="mt-5 mb-3">{{ $t("wizard.dinner") }}</p>
            <div class="night">
                <div
                v-ripple
                v-for="hour in hours.night"
                :key="hour"
                class="hour"
                :class="{
                    selected: isHourSelected(hour),
                    disabled:
                        !checkIfShiftAvaliable('night') || !hourIsAvailable(hour, 'night')
                }"
                @click="setHour({ hour: hour, shift: 'night' })"
                >
                <span class="">{{ hour }}</span>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from "vuex";
import axios from 'axios';

export default {
    data() {
        return {
            hours: {
                midday: ["13:00", "13:30", "14:00", "14:30", "15:00", "15:30"],
                night: ["20:00",  "20:30", "21:00", "21:30", "22:00", "22:30", "23:00"]
            },
            fetching: false,
            dateSchedule:[]
        };
    },
    computed: {
        ...mapGetters({
            hourSelected: "getHour",
            daySelected: "getDate",
            avaliableDates: "getAvaliableDates"
        }),
        shiftSchedule(){
            if(this.dateSchedule.length == 0){
                return this.dateSchedule;
            } else {
                let res= {midday:[], night:[]}
                this.dateSchedule.forEach(schedule => {
                    if(schedule[0]<'19:00'){
                        res.midday = schedule;
                    } else {
                        res.night = schedule;
                    }
                });
                return res;
            }
        }
    },
    watch: {
        daySelected(newDate, oldDate){
            if(newDate) {
                this.getDateSchedule(newDate);
            } else {
                this.dateSchedule = [];
            }
        }

    },
    methods: {
        ...mapMutations(["setHour"]),
        hourIsAvailable(hour, shift){
            return !this.hourIsInThePast(hour) && this.hourIsInSchedule(hour,shift);
        },
        getDateSchedule(date){
            this.fetching = true;
            axios.get(`/api/schedule/${date}`).then(res => this.dateSchedule = res.data)
        },
        isHourSelected(hour) {
            return this.hourSelected && this.hourSelected.hour == hour;
        },
        hourIsInSchedule(hour, shift){
            return this.shiftSchedule[shift][0] <= hour && hour <= this.shiftSchedule[shift][1];
        },
        checkIfShiftAvaliable(shift) {
            if (!this.daySelected) return false;
            //TODO: remove hardcoded

            if(moment(this.daySelected).day() ==0 && shift == 'night'){
                return false;
            }
            const dateAvaliable = this.avaliableDates.find(
                date => date.date == this.daySelected.split("T")[0]
            );
            if (dateAvaliable == null) return true;
            const shiftAvaliable = dateAvaliable.availability.find(
                s => s == shift
            );


            return shiftAvaliable && this.shiftSchedule[shift];
        },
        hourIsInThePast(hour) {
            if (!this.daySelected) {
                return false;
            }
            const [today, currentHour] = new Date()
                .toLocaleString("es-ES", {
                    timeZone: "Europe/Madrid",
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",
                    hour: "numeric"
                })
                .split(" ");
            const [day, month, year] = today.split("/");
            const dateSelectedIsToday =
                this.daySelected.slice(0, 10) === `${year}-${month}-${day}`;
            if (!dateSelectedIsToday) {
                return false;
            }
            return Number(hour.split(":")[0]) <= Number(currentHour);
        }
    }
};
</script>

<style lang="scss">
@import "../../../../sass/variables.scss";

.hours-section {
    flex-direction: column;
    display: flex;
    width: 100%;

    &__container {
        display: flex;
        flex-direction: column;

        .midday,
        .night{
            display: grid;
            gap: 10px;
            grid-template-columns: repeat(auto-fill, 58px);
        }

        .hour {
            height: 48px;
            width: 58px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #afafaf;
            cursor: pointer;
            border-radius: 6px;
            transition: all ease-in-out 0.1s;

            &:hover {
                background-color: #e4e4e4;
                border-color: #6f6f6f;
            }

            &.selected {
                background-color: $black;
                color: $white;
            }
            &.disabled {
                background-color: #edebe7;
                color: #bdbdbd;
                pointer-events: none;
                cursor: not-allowed;
            }
        }
    }
}
</style>
